module.exports = __webpack_public_path__ + "roboto-v15-latin-700.0d7e71f2b5cc1ddab837.woff2";


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/assets/layout/fonts/roboto-v15-latin-700.woff2
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-700.woff2
// module chunks = styles